import React, { useEffect, useState } from 'react'
import { Button, Card, Table } from "antd";
import { getWarehousesWithPage } from "../../services/serviceWarehouse";
import WarehouseCreate from "./WarehouseCreate";
import WarehouseActions from "./WarehouseActions";

const Warehouse = () => {
    const [sortedList, setSortedList] = useState([]);
    const [newModal, setNewModal] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getWarehouses(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getWarehouses = (page, pageSize) => {
        getWarehousesWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getWarehouses(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    warehouseName: item.name,
                    warehouseCode: item.code,
                    warehouseDescription: item.description,
                    warehousePhone: item.phone,
                    warehouseAddress: item.address,
                    warehouseRepresentative: item.representative
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    };

    const columns = [
        {
            title: 'Adı',
            dataIndex: 'warehouseName',
            key: 'warehouseName'
        },
        {
            title: 'Kodu',
            dataIndex: 'warehouseCode',
            key: 'warehouseCode'
        },
        {
            title: 'Sorumlu',
            dataIndex: 'warehouseRepresentative',
            key: 'warehouseRepresentative'
        },
        {
            title: 'Telefon',
            dataIndex: 'warehousePhone',
            key: 'warehousePhone'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <WarehouseActions record={record} updater={handlers.updater} />
        }
    ];

    return (
        <React.Fragment>
            <Card title={'Depo Listesi'} extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle </Button>}>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <WarehouseCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}

        </React.Fragment>
    )
}
export default Warehouse